import { render } from "./Profile.vue?vue&type=template&id=1c4ab3f0&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.css?vue&type=style&index=0&id=1c4ab3f0&scoped=true&lang=css&external"
import "./Profile.vue?vue&type=style&index=1&id=1c4ab3f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4ab3f0"]])

export default __exports__